var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.375C4.34111 1.375 1.375 4.34111 1.375 8C1.375 11.6589 4.34111 14.625 8 14.625C11.6589 14.625 14.625 11.6589 14.625 8C14.625 4.34111 11.6589 1.375 8 1.375ZM8 -6.99382e-07C12.4183 -3.13124e-07 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 -3.50157e-06 12.4183 -3.11532e-06 8C-2.72906e-06 3.58172 3.58172 -1.08564e-06 8 -6.99382e-07Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 12C7.3125 12.3797 7.62031 12.6875 8 12.6875C8.37969 12.6875 8.6875 12.3797 8.6875 12L8.6875 6.69544C8.6875 6.31573 8.37969 6.00794 8 6.00794C7.62031 6.00794 7.3125 6.31573 7.3125 6.69544L7.3125 12ZM8 5.3125C8.55228 5.3125 9 4.86478 9 4.3125C9 3.76022 8.55228 3.3125 8 3.3125C7.44772 3.3125 7 3.76022 7 4.3125C7 4.86478 7.44772 5.3125 8 5.3125Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9977001e079d4dae737fa4189a54cee2.svg";
export { ForwardRef as ReactComponent };